function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8417 2.43335L15.7584 4.61668C17.1751 5.24168 17.1751 6.27502 15.7584 6.90002L10.8417 9.08335C10.2834 9.33335 9.36672 9.33335 8.80839 9.08335L3.89172 6.90002C2.47506 6.27502 2.47506 5.24168 3.89172 4.61668L8.80839 2.43335C9.36672 2.18335 10.2834 2.18335 10.8417 2.43335Z",
  stroke: "#CCD2E3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 9.16663C2.5 9.86663 3.025 10.675 3.66667 10.9583L9.325 13.475C9.75833 13.6666 10.25 13.6666 10.675 13.475L16.3333 10.9583C16.975 10.675 17.5 9.86663 17.5 9.16663",
  stroke: "#64D5D2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 13.3334C2.5 14.1084 2.95833 14.8084 3.66667 15.125L9.325 17.6417C9.75833 17.8334 10.25 17.8334 10.675 17.6417L16.3333 15.125C17.0417 14.8084 17.5 14.1084 17.5 13.3334",
  stroke: "#64D5D2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLayer = function SvgLayer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/layer.82252a0b.svg";
export { ForwardRef as ReactComponent };